import React from 'react';
import { motion } from 'framer-motion';

export const UnstructuredDataPagination = ({
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  label,
}) => {
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, '...', totalPages - 2, totalPages - 1, totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, 2, 3, '...', totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(
          1,
          '...',
          currentPage - 1,
          currentPage,
          currentPage + 1,
          '...',
          totalPages
        );
      }
    }
    return pages;
  };

  const pages = getPageNumbers();

  return (
    <div className="flex flex-col justify-end items-end mt-6 w-full">
      <div className="text-xs text-white/60 dark:text-white/50 mb-2">
        Displaying {totalItems} {label} | Page {currentPage} of {totalPages}
      </div>
      <div className="flex items-center space-x-2 py-2">
        {/* Previous Button */}
        <motion.button
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          disabled={currentPage <= 1}
          className="px-3 py-1 text-sm rounded-full bg-white/10 text-white/80 disabled:opacity-40 hover:bg-white/20 transition dark:text-white"
          whileHover={{ scale: 1.05, y: -1 }}
        >
          Previous
        </motion.button>

        {/* Page Buttons */}
        {pages.map((page, index) =>
          page === '...' ? (
            <span
              key={index}
              className="px-3 py-1 text-white/50 select-none text-sm"
            >
              ...
            </span>
          ) : (
            <motion.button
              key={index}
              onClick={() => onPageChange(page)}
              className={`px-3 py-1 rounded-full text-sm transition backdrop-blur-sm border border-white/10 ${
                page === currentPage
                  ? 'bg-cyan-500 text-white'
                  : 'bg-white/10 text-white/80 hover:bg-white/20'
              }`}
              whileHover={{ scale: 1.05, y: -1 }}
            >
              {page}
            </motion.button>
          )
        )}

        {/* Next Button */}
        <motion.button
          onClick={() =>
            currentPage < totalPages && onPageChange(currentPage + 1)
          }
          disabled={currentPage >= totalPages}
          className="px-3 py-1 text-sm rounded-full bg-white/10 text-white/80 disabled:opacity-40 hover:bg-white/20 transition dark:text-white"
          whileHover={{ scale: 1.05, y: -1 }}
        >
          Next
        </motion.button>
      </div>
    </div>
  );
};
